// Adarshabani Academics × KinetiX brand mark. Inlined SVG path from
// `KinetiX Adarshabani 01 Artboard 1.svg`. Uses `currentColor` so the mark
// inherits text color (we set `text-white` on the wrapper for the dark theme).
//
// We embed only the foreground `Logo` path — the source artwork has a second
// `Shadow` path offset behind it for the dual-tone print look, which collapses
// to a smudge when both are rendered white-on-white.

import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

export default function LogoMark(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1920"
      aria-label="KinetiX Adarshabani"
      role="img"
      {...props}
    >
      <path
        fill="currentColor"
        d="M421.53,1433c-16.06,5.61-31.16,12.24-46.94,15.99c-40.24,9.56-73.99-27.85-61.51-67.46
          c4.34-13.77,10.13-27.14,13.68-41.09c6.57-25.86,11.53-52.13,17.96-78.03c8.77-35.35,18.32-70.51,27.49-105.77
          c12.58-48.32,24.36-96.86,37.91-144.91c10.65-37.76,23.84-74.8,35.2-112.38c12.72-42.08,24.66-84.39,36.88-126.62
          c5.02-17.35,6.32-35.21,6.89-53.14c0.28-8.8,0.13-17.61,0.48-26.4c0.87-21.84,14.75-37.46,36.2-40.36
          c5.43-0.73,10.15-2.43,14.96-4.95c14.12-7.4,29.13-8.52,43.74-2.39c17.4,7.31,34.35,15.98,47.94,29.42
          c7.76,7.67,14.82,16.26,21.02,25.25c9.27,13.43,17.44,27.61,26.19,41.4c9.8,15.45,18.41,31.36,23.05,49.29
          c2.66,10.28,7.8,20.01,9.73,30.37c1.56,8.4,1.34,17.67-0.42,26.06c-5.62,26.77-30.47,40.97-56.78,33.35
          c-16.25-4.71-28.41-15.3-38.89-28.76c-0.48-0.61,5,5.65,4.32,5.27c-17.01-9.53-28.83-35.02-41.92-49.26
          c-2.45-2.67-13.81,1.25-16.21-1.47c-0.92,3.66-2.1,7.25-2.99,10.92c-13.38,54.92-26.53,109.9-40.16,164.76
          c-9.38,37.78-19.62,75.36-29.1,113.12c-8.71,34.72-16.9,69.57-25.3,104.37c-0.29,1.19-0.31,2.44-0.67,5.39
          c2.74-2.31,4.6-3.58,6.09-5.19c14.32-15.44,28.36-31.15,42.91-46.36c32.37-33.85,65.44-67.03,97.36-101.28
          c28.71-30.8,55.88-63.04,84.43-93.99c48.8-52.91,98.55-104.94,147.18-158c77.11-84.12,155.42-167.13,236.13-247.76
          c58.06-58,114.23-117.76,171.19-176.77c29.01-30.05,62.98-51.72,103.77-62.03c1.82-0.46,3.63-1.06,5.48-1.36
          c13.61-2.2,26.64-5.65,39.68-10.76c50.53-19.79,105.23,4.4,128.33,55.34c12.67,27.96,14.73,57.25,9.01,86.78
          c-8.09,41.76-11.05,84.08-16.33,126.16c-4.33,34.6-8.62,69.25-14.52,103.6c-13.25,77.08-27.03,154.08-41.5,230.94
          c-10.4,55.24-22.48,110.16-33.4,165.3c-12.99,65.63-26.2,131.22-38.03,197.07c-6.66,37.08-10.56,74.65-16.02,111.95
          c-5.77,39.47-11.76,78.92-17.99,118.32c-2.35,14.88-5.27,29.69-8.59,44.39c-10.08,44.66-43.24,75.75-88.44,82.89
          c-12.81,2.02-25.78,1.59-38.4-1.65c-11.54-2.96-23.03-6.23-34.33-10.02c-19.92-6.69-36.17-18.8-48.85-35.48
          c-29.28-38.53-58.41-77.16-87.56-115.78c-12.12-16.05-24.61-31.85-36.11-48.33c-16.16-23.18-32.89-46.13-46.94-70.58
          c-17.61-30.64-37.45-59.54-59.4-87.1c-7.44-9.34-15.27-18.36-22.84-27.59c-13.01-15.86-21.75-33.62-24.8-54.13
          c-7.18-48.33,32.65-88.26,81.08-81.31c29.24,4.2,51.06,19.84,68.06,43.12c23.37,32.01,44.54,65.35,63.44,100.27
          c13.89,25.65,29.65,50.35,45.59,74.81c11.44,17.57,28.04,30.86,41.7,46.62c0.92-7.51,2.18-14.98,2.9-22.5
          c3.17-32.84,5.67-65.76,9.49-98.53c3.05-26.19,7.48-52.23,11.61-78.29c6.69-42.19,13.11-84.44,20.64-126.48
          c6.09-34,13.95-67.68,20.49-101.6c7.85-40.71,15-81.55,22.69-122.29c7.05-37.34,14.43-74.63,21.63-111.94
          c0.58-2.99,0.91-6.02,1.7-11.36c-4.01,3.43-6.41,5.25-8.53,7.34c-41.2,40.58-82.6,80.96-123.48,121.85
          c-70.91,70.93-144.13,139.43-217.29,208c-50.91,47.72-101.63,95.65-153.34,142.48c-51.08,46.26-107.3,86.16-161.95,128
          c-36.67,28.07-71.86,58.06-107.83,87.05C475.71,1398.7,450.5,1417.97,421.53,1433z"
      />
    </svg>
  );
}
